var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBianjiZhuanfa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.25v-.5a.5.5 0 00-.5.5h.5zm0 5.5H1a.5.5 0 00.5.5v-.5zm7.09 0h.5a.5.5 0 00-.5-.5v.5zm0 2.75h-.5a.5.5 0 00.842.366L8.59 13.5zM14.5 8l.34.366a.5.5 0 000-.732L14.5 8zM8.59 2.5l.342-.366a.5.5 0 00-.841.366h.5zm0 2.75v.5a.5.5 0 00.5-.5h-.5zM1 5.25v5.5h1v-5.5H1zm.5 6h7.09v-1H1.5v1zm7.432 2.616l5.909-5.5-.682-.732-5.909 5.5.682.732zm5.909-6.232l-5.91-5.5-.68.732 5.908 5.5.682-.732zM8.09 2.5v2.75h1V2.5h-1zm.5 2.25H1.5v1h7.09v-1zm-.5 6v1.375h1V10.75h-1zm0 1.375V13.5h1v-1.375h-1z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/bianji_zhuanfa.6a80d535.svg";
export { SvgBianjiZhuanfa as ReactComponent };